// 模拟数据

import { Book, User, BorrowRecord, Category, DashboardStats } from './types';

export const categories: Category[] = [
  { id: '1', name: '文学小说', description: '中外文学、小说作品', bookCount: 1256, icon: 'BookOpen', color: '#3B82F6' },
  { id: '2', name: '科学技术', description: '计算机、工程、自然科学', bookCount: 892, icon: 'Cpu', color: '#10B981' },
  { id: '3', name: '历史人文', description: '历史、哲学、艺术', bookCount: 743, icon: 'Landmark', color: '#8B5CF6' },
  { id: '4', name: '经济管理', description: '经济、管理、金融', bookCount: 628, icon: 'TrendingUp', color: '#F59E0B' },
  { id: '5', name: '教育考试', description: '教材、考试、教辅', bookCount: 445, icon: 'GraduationCap', color: '#EF4444' },
  { id: '6', name: '生活休闲', description: '生活、旅游、美食', bookCount: 332, icon: 'Coffee', color: '#EC4899' },
];

export const books: Book[] = [
  {
    id: '1',
    isbn: '978-7-111-51354-2',
    title: '深入理解计算机系统',
    author: 'Randal E. Bryant',
    publisher: '机械工业出版社',
    publishDate: '2016-11',
    category: '科学技术',
    description: '计算机科学经典教材，深入讲解计算机系统原理',
    cover: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&q=80',
    status: 'available',
    location: 'A区-3排-2层',
    quantity: 5,
    borrowedCount: 128,
    createdAt: '2023-01-15',
    updatedAt: '2024-01-10'
  },
  {
    id: '2',
    isbn: '978-7-020-12345-6',
    title: '百年孤独',
    author: '加西亚·马尔克斯',
    publisher: '人民文学出版社',
    publishDate: '2011-06',
    category: '文学小说',
    description: '魔幻现实主义文学代表作',
    cover: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80',
    status: 'borrowed',
    location: 'B区-1排-3层',
    quantity: 8,
    borrowedCount: 256,
    createdAt: '2023-01-20',
    updatedAt: '2024-01-15'
  },
  {
    id: '3',
    isbn: '978-7-302-12345-6',
    title: '设计模式：可复用面向对象软件的基础',
    author: 'Erich Gamma',
    publisher: '清华大学出版社',
    publishDate: '2020-01',
    category: '科学技术',
    description: '软件工程领域经典著作',
    cover: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=400&q=80',
    status: 'available',
    location: 'A区-2排-1层',
    quantity: 3,
    borrowedCount: 89,
    createdAt: '2023-02-01',
    updatedAt: '2024-01-12'
  },
  {
    id: '4',
    isbn: '978-7-508-61234-5',
    title: '人类简史',
    author: '尤瓦尔·赫拉利',
    publisher: '中信出版社',
    publishDate: '2017-02',
    category: '历史人文',
    description: '从动物到上帝的人类发展史',
    cover: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400&q=80',
    status: 'available',
    location: 'C区-1排-2层',
    quantity: 6,
    borrowedCount: 312,
    createdAt: '2023-02-10',
    updatedAt: '2024-01-08'
  },
  {
    id: '5',
    isbn: '978-7-111-23456-7',
    title: '算法导论',
    author: 'Thomas H. Cormen',
    publisher: '机械工业出版社',
    publishDate: '2013-01',
    category: '科学技术',
    description: '算法领域的权威教材',
    cover: 'https://images.unsplash.com/photo-1509228468518-180dd4864904?w=400&q=80',
    status: 'borrowed',
    location: 'A区-1排-1层',
    quantity: 4,
    borrowedCount: 167,
    createdAt: '2023-03-01',
    updatedAt: '2024-01-14'
  },
  {
    id: '6',
    isbn: '978-7-020-23456-7',
    title: '红楼梦',
    author: '曹雪芹',
    publisher: '人民文学出版社',
    publishDate: '2008-07',
    category: '文学小说',
    description: '中国古典文学四大名著之首',
    cover: 'https://images.unsplash.com/photo-1535905557558-afc4877a26fc?w=400&q=80',
    status: 'available',
    location: 'B区-2排-1层',
    quantity: 10,
    borrowedCount: 423,
    createdAt: '2023-03-05',
    updatedAt: '2024-01-11'
  },
  {
    id: '7',
    isbn: '978-7-508-62345-6',
    title: '穷查理宝典',
    author: '查理·芒格',
    publisher: '中信出版社',
    publishDate: '2016-08',
    category: '经济管理',
    description: '查理·芒格的智慧箴言录',
    cover: 'https://images.unsplash.com/photo-1550399105-c4db5fb85c18?w=400&q=80',
    status: 'reserved',
    location: 'D区-1排-1层',
    quantity: 3,
    borrowedCount: 78,
    createdAt: '2023-03-15',
    updatedAt: '2024-01-13'
  },
  {
    id: '8',
    isbn: '978-7-302-23456-7',
    title: '机器学习',
    author: '周志华',
    publisher: '清华大学出版社',
    publishDate: '2016-01',
    category: '科学技术',
    description: '机器学习领域入门经典',
    cover: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=400&q=80',
    status: 'available',
    location: 'A区-4排-1层',
    quantity: 7,
    borrowedCount: 234,
    createdAt: '2023-04-01',
    updatedAt: '2024-01-09'
  },
];

export const users: User[] = [
  {
    id: '1',
    name: '张三',
    email: 'zhangsan@example.com',
    phone: '13800138001',
    avatar: 'https://images.unsplash.com/photo-1552158732-06dc1d835de0?w=200&q=80',
    role: 'admin',
    status: 'active',
    maxBooks: 20,
    borrowedBooks: 2,
    joinDate: '2023-01-01',
    expiryDate: '2025-12-31'
  },
  {
    id: '2',
    name: '李四',
    email: 'lisi@example.com',
    phone: '13800138002',
    avatar: 'https://images.unsplash.com/photo-1650056200016-70c0cb987ce7?w=200&q=80',
    role: 'librarian',
    status: 'active',
    maxBooks: 15,
    borrowedBooks: 1,
    joinDate: '2023-02-15',
    expiryDate: '2025-12-31'
  },
  {
    id: '3',
    name: '王五',
    email: 'wangwu@example.com',
    phone: '13800138003',
    avatar: 'https://images.unsplash.com/photo-1740252117027-4275d3f84385?w=200&q=80',
    role: 'reader',
    status: 'active',
    maxBooks: 5,
    borrowedBooks: 3,
    joinDate: '2023-03-10',
    expiryDate: '2024-12-31'
  },
  {
    id: '4',
    name: '赵六',
    email: 'zhaoliu@example.com',
    phone: '13800138004',
    avatar: 'https://images.unsplash.com/photo-1655874819398-c6dfbec68ac7?w=200&q=80',
    role: 'reader',
    status: 'suspended',
    maxBooks: 5,
    borrowedBooks: 0,
    joinDate: '2023-04-20',
    expiryDate: '2024-06-30'
  },
  {
    id: '5',
    name: '钱七',
    email: 'qianqi@example.com',
    phone: '13800138005',
    avatar: 'https://images.unsplash.com/photo-1729337531424-198f880cb6c7?w=200&q=80',
    role: 'reader',
    status: 'active',
    maxBooks: 10,
    borrowedBooks: 1,
    joinDate: '2023-05-01',
    expiryDate: '2025-05-01'
  },
];

export const borrowRecords: BorrowRecord[] = [
  {
    id: '1',
    bookId: '2',
    bookTitle: '百年孤独',
    bookCover: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200&q=80',
    userId: '3',
    userName: '王五',
    borrowDate: '2024-01-01',
    dueDate: '2024-01-31',
    returnDate: null,
    status: 'borrowed',
    fine: 0,
    notes: ''
  },
  {
    id: '2',
    bookId: '5',
    bookTitle: '算法导论',
    bookCover: 'https://images.unsplash.com/photo-1509228468518-180dd4864904?w=200&q=80',
    userId: '3',
    userName: '王五',
    borrowDate: '2024-01-05',
    dueDate: '2024-02-05',
    returnDate: null,
    status: 'borrowed',
    fine: 0,
    notes: ''
  },
  {
    id: '3',
    bookId: '1',
    bookTitle: '深入理解计算机系统',
    bookCover: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=200&q=80',
    userId: '2',
    userName: '李四',
    borrowDate: '2023-12-15',
    dueDate: '2024-01-15',
    returnDate: '2024-01-10',
    status: 'returned',
    fine: 0,
    notes: '提前归还'
  },
  {
    id: '4',
    bookId: '4',
    bookTitle: '人类简史',
    bookCover: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=200&q=80',
    userId: '5',
    userName: '钱七',
    borrowDate: '2023-12-20',
    dueDate: '2024-01-20',
    returnDate: null,
    status: 'overdue',
    fine: 15,
    notes: '逾期未还'
  },
  {
    id: '5',
    bookId: '6',
    bookTitle: '红楼梦',
    bookCover: 'https://images.unsplash.com/photo-1535905557558-afc4877a26fc?w=200&q=80',
    userId: '1',
    userName: '张三',
    borrowDate: '2024-01-10',
    dueDate: '2024-02-10',
    returnDate: null,
    status: 'borrowed',
    fine: 0,
    notes: ''
  },
  {
    id: '6',
    bookId: '3',
    bookTitle: '设计模式',
    bookCover: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=200&q=80',
    userId: '4',
    userName: '赵六',
    borrowDate: '2023-11-01',
    dueDate: '2023-12-01',
    returnDate: null,
    status: 'overdue',
    fine: 50,
    notes: '长期逾期，账户已暂停'
  },
];

export const dashboardStats: DashboardStats = {
  totalBooks: 4296,
  totalUsers: 1258,
  activeBorrows: 342,
  overdueBooks: 28,
  todayBorrows: 15,
  todayReturns: 12,
  monthlyTrend: [
    { month: '8月', borrows: 180, returns: 165 },
    { month: '9月', borrows: 220, returns: 210 },
    { month: '10月', borrows: 195, returns: 188 },
    { month: '11月', borrows: 240, returns: 225 },
    { month: '12月', borrows: 280, returns: 260 },
    { month: '1月', borrows: 156, returns: 145 },
  ]
};
